import { Skeleton, Box, Grid, Card, CardContent, Container } from '@mui/material';

export function DealPageSkeleton() {
  return (
    <Box component="main" sx={{ flexGrow: 1, pt: 8 }}>
      <Container>
        <Grid container spacing={4}>
          <Grid size={{ xs:12, md:6}}>
            <Skeleton variant="rectangular" width="100%" height={400} />
          </Grid>
          <Grid size={{ xs:12, md:6}}>
            <Card sx={{ height: 400 }}>
              <CardContent>
                <Skeleton variant="text" width="60%" height={32} />
                <Skeleton variant="text" width="40%" height={28} />
                <Skeleton variant="text" width="50%" height={28} />
                <Skeleton variant="text" width="80%" height={24} sx={{ mt: 2 }} />
                <Skeleton variant="text" width="90%" height={20} />
                <Skeleton variant="rounded" width="60%" height={32} sx={{ mt: 2 }} />
              </CardContent>
            </Card>
          </Grid>
          <Grid size={12}>
            <Skeleton variant="text" width="30%" height={28} />
            <Skeleton variant="rounded" width="100%" height={150} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
